export const DRILL_DOWN_TARGET_ATTRIBUTE = 'data-drilldown-target';
